module.exports = __webpack_public_path__ + "assets/img/portfolio-big-07.cf9db51f.png";